
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import SettingsFormItem from './views/FormItem/index.vue'
import Input from './views/Input/index.vue'
import TextArea from './views/TextArea/index.vue'
import Select from './views/Select/index.vue'
import MultipleSelect from './views/MultipleSelect/index.vue'
import DatePicker from './views/DatePicker/index.vue'
import Divider from './views/Divider/index.vue'
import Cascader from './views/Cascader/index.vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import UpdateAvatar from './views/UpdateAvatar/index.vue'
import { Observer } from 'mobx-vue'
import { dataSource_My } from '@xt/client'
import type { UserInfo } from '@xt/client/entities/user/types'
import { getLocationCascader } from '@xt/client/dataSource/china/index'
import lodash from 'lodash'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import { EnumOpenMiniProgramPage } from '@xt/client/enums/mini/index'
import { EnumSexType } from '@xt/client/enums/user/index'
import { Bind, Debounce } from 'lodash-decorators'
import { FormatLocationType } from '@xt/client/entities/location'
import { reportEntryLog } from '@xt/client/utils/log'

@Observer
@Component({
  components: {
    SettingsFormItem,
    Input,
    Select,
    MultipleSelect,
    DatePicker,
    Divider,
    Cascader,
    HeaderImage,
    UpdateAvatar,
    LazyImg,
    Qrcode,
    TextArea
  }
})
export default class MySettingsMyself extends Vue {
  userInfoValue: (UserInfo & { locationCascader: [] }) | null = null

  // 地区 配置
  countryOptions: FormatLocationType | null = null

  showPopover: boolean = false
  loading: boolean = true

  get EnumOpenMiniProgramPage() {
    return EnumOpenMiniProgramPage
  }

  get dataSource_My() {
    return dataSource_My
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  onMouseEnter() {
    this.showPopover = true
  }

  onMouseLeave() {
    this.showPopover = false
  }

  @Debounce(300, { leading: true, trailing: false })
  @Bind()
  async onUpdate() {
    try {
      if (!this.userInfoValue) return

      let data = lodash.cloneDeep(this.userInfoValue)
      // 转换地址
      data = getLocationCascader(data, true)

      await this.UserStore.onUpdateUserInfo(data)

      this.$msg(this.$EnumMessage.save_success, 'success')

      const res = await this.UserStore.onUpdatingUserInfo()

      if (!res) return

      this.onUpdateUserInfoValue(res)
    } catch (error) {
      this.$msg(error)
    }
  }

  async onUpdateUserInfoValue(userInfo: UserInfo) {
    let data = lodash.pick(userInfo, [
      'nickname', // 昵称
      'address', // 地址
      'birthday', // 生日
      'career', // 职业
      'education', // 学历
      'id', //id
      'industry', // 行业
      'location', // 所在地（0 未知，1 国内，2国外）
      'city', // 城市
      'country', // 国家
      'province', // 省份
      'sex', // 性别(0 未知 1 男 2女)
      'summary', // 简介
      'specialty', // 特长
      'wxUsername' // 微信号
    ])

    data = lodash.mapValues(data, (val, key) => {
      // 特殊处理性别：只允许 1 和 2
      if (key === 'sex') {
        return [EnumSexType.Man, EnumSexType.Woman].includes(val) ? val : undefined
      }
      // 处理其他字段的空值 /null 情况
      return val === '' || val === null ? undefined : val
    })

    this.userInfoValue = {
      ...getLocationCascader(data)
    }
  }

  async init() {
    try {
      this.loading = true
      // 获取所在地
      this.countryOptions = await this.$store.$location.onGetLocationResource()

      this.onUpdateUserInfoValue(this.toJS(this.UserStore.UserInfo))
    } catch (error) {
      reportEntryLog('my-settings-myself.init.fail', error)
    } finally {
      this.loading = false
    }
  }

  created() {
    this.init()
  }

  mounted() {}

  updated() {}

  destroyed() {}
}
